import { Profile } from '@/types'
import { useMutation, useQuery } from '@tanstack/react-query'
import { QueryKeys } from './queryKeys'
import { create, retrieve, update } from './views'
import { ReactQuery } from '@codeleap/common'
import { useFirebaseUser } from '@/features/Auth/identity/useFirebaseUser'

type UseProfileOptions = ReactQuery.UseQueryOptions<Profile>

export const useProfile = (options: UseProfileOptions = {}) => {
  const fbUser = useFirebaseUser()

  return useQuery({
    ...options,
    queryKey: QueryKeys.me.key(),
    queryFn: retrieve,
    refetchOnWindowFocus: false,
    refetchOnMount(q) {
      return q.state.dataUpdateCount == 0
    },
    retry: 3,
    enabled: !!fbUser?.uid
  })
}

export const useCreateProfile = () => {
  const createProfile = useMutation({
    mutationKey: QueryKeys.create.key,
    mutationFn: create,
    onSuccess: () => {
      QueryKeys.me.refresh()
    }
  })

  return createProfile
}

export const useUpdateProfile = () => {
  const updateProfile = useMutation({
    mutationKey: QueryKeys.create.key,
    mutationFn: update,
    onSuccess: () => {
      QueryKeys.me.refresh()
    }
  })

  return updateProfile
}
